import SwiperSlider from './SwiperSlider';

export default class SliderIcons {
  init() {
    const blockSliderIconsList = Array.from(
      document.querySelectorAll('.slider-icons')
    );

    for (let blockSliderIcons of blockSliderIconsList) {
      new SwiperSlider(blockSliderIcons.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 10,
        breakpoints: {
          768: {
            spaceBetween: 30,
          },
          1024: {
            spaceBetween: 60,
          },
        },
        navigation: {
          nextEl: blockSliderIcons.querySelector('.swiper-button-next'),
          prevEl: blockSliderIcons.querySelector('.swiper-button-prev'),
        },
      });
    }
  }
}
